/* istanbul ignore file */

import SVG_google from "@/shared/assets/svg_used/google.svg";
import SVG_facebook from "@/shared/assets/svg_used/facebook.svg";
import SVG_trustpilotStar from "@/shared/assets/svg_used/trustpilotStar.svg";
import SVG_trustpilotStar5 from "@/shared/assets/svg_used/trustpilotStar5.svg";
import SVG_trustpilotStar5New from "@/shared/assets/svg_used/trustpilotStar5New.svg";
import SVG_trustpilotStarEmpty from "@/shared/assets/svg_used/trustpilotStarEmpty.svg";
import SVG_trustpilotStarHalf from "@/shared/assets/svg_used/trustpilotStarHalf.svg";
import SVG_trustpilotLogoWhiteText from "@/shared/assets/svg_used/trustpilotLogoWhiteText.svg";
import SVG_leftDecoration from "@/shared/assets/svg_used/leftDecoration.svg";
import SVG_rightDecoration from "@/shared/assets/svg_used/rightDecoration.svg";
import SVG_confetti from "@/shared/assets/svg_used/confetti.svg";
import SVG_googleLogo from "@/shared/assets/svg_used/googleLogo.svg";
import SVG_directions from "@/shared/assets/svg_used/hiw_directions.svg";
import SVG_search from "@/shared/assets/svg_used/hiw_search.svg";
import SVG_thumb from "@/shared/assets/svg_used/hiw_thumb.svg";
import SVG_arrowRight from "@/shared/assets/svg_used/ArrowRight.svg";
import SVG_arrowLeft from "@/shared/assets/svg_used/ArrowLeft.svg";
import SVG_playButton from "@/shared/assets/svg_used/PlayButton.svg";
import SVG_playIcon from "@/shared/assets/svg_used/PlayIcon.svg";
import SVG_trustpilot from "@/shared/assets/svg_used/trustpilot.svg";
import SVG_remindmelogo from "@/shared/assets/svg_used/appLogo.svg";
import SVG_topdeals from "@/shared/assets/svg_used/topdeals.svg";
import SVG_freundschaft from "@/shared/assets/svg_used/freundschaft.svg";
import SVG_erinnerungen from "@/shared/assets/svg_used/erinnerungen.svg";
import SVG_pramien from "@/shared/assets/svg_used/pramien.svg";
import SVG_questionMark from "@/shared/assets/svg_used/questionMark.svg";
import SVG_checkProcess from "@/shared/assets/svg_used/checkProcess.svg";
import SVG_contractConfirmation from "@/shared/assets/svg_used/contractConfirmation.svg";
import SVG_offer from "@/shared/assets/svg_used/offer.svg";
import SVG_starSolid from "@/shared/assets/svg_used/starSolid.svg";
import SVG_starRegular from "@/shared/assets/svg_used/starRegular.svg";

export default {
  SVG_google,
  SVG_facebook,
  SVG_trustpilotStar,
  SVG_trustpilotStar5,
  SVG_trustpilotStar5New,
  SVG_trustpilotStarEmpty,
  SVG_trustpilotStarHalf,
  SVG_trustpilotLogoWhiteText,
  SVG_leftDecoration,
  SVG_rightDecoration,
  SVG_confetti,
  SVG_googleLogo,
  SVG_directions,
  SVG_search,
  SVG_thumb,
  SVG_arrowRight,
  SVG_arrowLeft,
  SVG_playButton,
  SVG_playIcon,
  SVG_trustpilot,
  SVG_remindmelogo,
  SVG_topdeals,
  SVG_freundschaft,
  SVG_erinnerungen,
  SVG_pramien,
  SVG_questionMark,
  SVG_checkProcess,
  SVG_contractConfirmation,
  SVG_offer,
  SVG_starSolid,
  SVG_starRegular
};
